import * as tslib_1 from "tslib";
import { Base } from '../base-component';
import CheckEligibility from '../../services/check-eligibility.service';
import { AnalyticsService } from '../../services/analytics.service';
import axios from 'axios';
import './form-item-cmb-eligibility-business.component.scss';
import * as $ from 'jquery';
var FormItemCmbEligibilityBusiness = /** @class */ (function (_super) {
    tslib_1.__extends(FormItemCmbEligibilityBusiness, _super);
    function FormItemCmbEligibilityBusiness(element) {
        return _super.call(this, element) || this;
    }
    FormItemCmbEligibilityBusiness.prototype.init = function () {
        this.checkEligibility = new CheckEligibility();
        this.form = this.element.querySelector('form');
        this.selectTitle = this.element.querySelector('.js-title');
        this.selectCountries = this.form.querySelector('select[name=companyCountriesOperating]');
        this.buttonSubmit = Array.from(this.element.querySelectorAll('.js-apply-now__button'));
        this.hidLeadId = this.form.querySelector('input[name=leadId]');
        this.hidProduct = this.form.querySelector('input[name=product]');
    };
    FormItemCmbEligibilityBusiness.prototype.bindEvents = function () {
        var _this = this;
        this.buttonSubmit.map(function (item) { return item.addEventListener('click', function (event) {
            var formFields = _this.form.querySelectorAll('input, select, textarea');
            var validation = _this.validationService.validateEnterprise(formFields);
            if (validation.valid) {
                _this.actionForm(_this.form, _this.element.querySelector('.form__loader--container'), _this.element.querySelector('.form__thankyou--container'));
            }
        }); });
        $(document).on('click', '.js-apply-now-modal-open', function (event) {
            var element = event.target;
            var parentAttribute = "";
            if (element.closest('.product-offering-exchange__button')) {
                parentAttribute = element.closest('.product-offering-exchange__button').getAttribute('data-buttonclass');
            }
            if (element.closest('.comparison-exchange__product__button')) {
                parentAttribute = element.closest('.comparison-exchange__product__button').getAttribute('data-buttonclass');
            }
            if (element.closest('.detailed-product-card-exchange__buttons-js')) {
                parentAttribute = element.closest('.detailed-product-card-exchange__buttons-js').getAttribute('data-buttonclass');
            }
            if (parentAttribute === 'CallMeBack') {
                var type = $(element).attr('data-productname');
                var leadid = $(element).attr('data-leadid');
                var modalId = $(element).attr('data-modal');
                if (type) {
                    _this.hidProduct.value = type;
                }
                if (leadid) {
                    _this.hidLeadId.value = leadid;
                }
                if (modalId) {
                    _this.hidCallMeBackModalId = modalId;
                }
                // APPLICATION ID
                var valueProductID = $(element).closest('.js-product-id').attr('data-productid');
                var valueEligibilityFormID = $(element).closest('.js-product-id').find('div[data-buttonclass=Eligibility]').find('.js-apply-now-modal-open').attr('data-modal');
                console.log('Modal ID', valueEligibilityFormID);
                console.log('Product ID', valueProductID);
                _this.checkEligibility.checkApplicationID(valueEligibilityFormID, valueProductID);
            }
        });
        if (this.selectCountries) {
            this.selectCountries.addEventListener('change', function (event) {
                var values = [].slice.call(event.target.selectedOptions).map(function (a) { return a.value; });
                var result = values.join(', ');
                _this.hidActivitiesTakePlace = result;
            });
        }
    };
    FormItemCmbEligibilityBusiness.prototype.addMoreTitle = function (element) {
        if (element) {
            if (element.value == 'Other') {
                var parentParent = element.closest('.form__fields--container');
                var parent_1 = element.closest('.form__group');
                var newContainer = document.createElement('div');
                newContainer.classList.add('form__group');
                newContainer.classList.add('js-other-title-container');
                var newLabel = document.createElement('label');
                newLabel.classList.add('form__label');
                newLabel.innerHTML = 'Other Title';
                newContainer.appendChild(newLabel);
                var newInput = document.createElement('input');
                newInput.classList.add('js-other-title');
                newInput.classList.add('form__input');
                newInput.classList.add('form__input--required');
                newInput.setAttribute('placeholder', 'Enter your title');
                newInput.setAttribute('maxlength', '4');
                newInput.setAttribute('name', 'manager-name');
                newContainer.appendChild(newInput);
                parentParent.insertBefore(newContainer, parent_1.nextSibling);
            }
            else {
                var parentParent = element.closest('.form__fields--container');
                var oldInput = this.element.querySelector('.js-other-title-container');
                parentParent.removeChild(oldInput);
            }
        }
    };
    FormItemCmbEligibilityBusiness.prototype.resetForm = function () {
        if (this.form) {
            this.form.reset();
            var formContainerLoader = this.element.querySelector('.form__loader--container');
            var formContainerFields = this.element.querySelector('.form__fields--container');
            var formContainerThankyou = this.element.querySelector('.form__thankyou--container');
            formContainerThankyou.classList.remove('active');
            formContainerFields.classList.remove('hidden');
        }
    };
    FormItemCmbEligibilityBusiness.prototype.actionForm = function (form, loader, thankyou) {
        // fields
        var productType = this.form.querySelector('input[name=product]');
        var leadID = this.form.querySelector('input[name=leadId]');
        var companyName = this.form.querySelector('input[name=companyName]');
        var companyContactName = form.querySelector('input[name=companyContactName]');
        var dialCode = form.querySelector('select[name=dialCode]');
        var telNo = form.querySelector('input[name=telNo]');
        var emailAddress = form.querySelector('input[name=emailAddress]');
        var websiteAddress = form.querySelector('input[name=websiteAddress]');
        var companyPrimaryActivities = form.querySelector('select[name=companyPrimaryActivities]');
        var companyCountryBased = form.querySelector('select[name=companyCountryBased]');
        var companyCountriesOperating = form.querySelector('select[name=companyCountriesOperating]');
        var pageUrl = window.location.href;
        var applicationID = this.checkEligibility.applicationID;
        var productID = this.checkEligibility.applicationProductID;
        var postData = '';
        postData += 'operation=submit&';
        postData += 'category=business&';
        if (productType) {
            postData += 'productName=' + productType.value + '&';
        }
        if (leadID) {
            postData += 'leadID=' + leadID.value + '&';
        }
        if (this.hidCallMeBackModalId) {
            postData += 'callmebackFormId=' + this.hidCallMeBackModalId + '&';
        }
        if (companyName) {
            postData += 'companyName=' + companyName.value + '&';
        }
        if (companyContactName) {
            postData += 'companyContactName=' + companyContactName.value + '&';
        }
        if (dialCode) {
            postData += 'dialCode=' + dialCode.value + '&';
        }
        if (telNo) {
            postData += 'telNo=' + telNo.value + '&';
        }
        if (emailAddress) {
            postData += 'emailAddress=' + emailAddress.value + '&';
        }
        if (websiteAddress) {
            postData += 'websiteAddress=' + websiteAddress.value + '&';
        }
        if (companyPrimaryActivities) {
            postData += 'companyPrimaryActivities=' + companyPrimaryActivities.value + '&';
        }
        if (companyCountryBased) {
            postData += 'companyCountryBased=' + companyCountryBased.value + '&';
        }
        if (this.hidActivitiesTakePlace) {
            postData += 'companyCountriesOperating=' + this.hidActivitiesTakePlace + '&';
        }
        if (pageUrl) {
            postData += 'pageUrl=' + pageUrl + '&';
        }
        if (applicationID) {
            postData += 'appID=' + applicationID + '&';
        }
        if (productID) {
            postData += 'productID=' + productID + '&';
        }
        // loader + hide form
        var fieldsContainer = form.querySelector('.form__fields--container');
        loader.classList.add('active');
        fieldsContainer.classList.add('hidden');
        // variables
        var analyticsService = new AnalyticsService();
        var url = "/services/SubmitWINLead.jsp";
        var config = {
            headers: {
                'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8',
                "Access-Control-Allow-Origin": "*",
                'X-Requested-With': 'XMLHttpRequest'
            }
        };
        // service
        axios.post(url, postData, config).then(function (response) {
            // service ok
            loader.classList.remove('active');
            loader.classList.remove('active');
            thankyou.classList.add('active');
            analyticsService.dtmFormComplete('complete', '');
        }).catch(function (response) {
            // service failed
            loader.classList.remove('active');
            thankyou.classList.add('active');
            analyticsService.dtmFormComplete('complete', '');
        });
    };
    return FormItemCmbEligibilityBusiness;
}(Base));
export { FormItemCmbEligibilityBusiness };



//////////////////
// WEBPACK FOOTER
// ./components/form-item-cmb-eligibility-business/form-item-cmb-eligibility-business.component.ts
// module id = 321
// module chunks = 0